import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'

const tramImage = '../images/tram.svg'

type TitleTagType = keyof JSX.IntrinsicElements

interface LogoutContentProps {
    layout?: string
    titleTag?: TitleTagType
}

/**
 * Content shown on the logout page with a return-to-login button.
 */
const LogoutContent = ({
    titleTag: TitleTag = 'h4',
}: LogoutContentProps) => {
    const [t] = useTranslation()

    return (
        <Fragment>
            <img
                className='d-block mx-auto mb-4'
                src={tramImage}
                alt='shield'
                width={70}
            />
            <TitleTag>{t('logoutBox.title')}</TitleTag>
            <p>{t('logoutBox.logoutSuccess')}</p>
            <Button
                tag={Link}
                color='primary'
                size='sm'
                className='mt-3'
                to={`/login`}
            >
                {t('logoutBox.returnToLoginButton')}
            </Button>
        </Fragment>
    )
}

export default LogoutContent
